<template>
  <v-list-item :class="large ? 'search-tile' : 'search-tile-large'" color="card">
    <v-list-item-avatar rounded :height="(large ? 100 : 64) / aspect" :width="large ? 100 : 64">
      <v-img :src="image"></v-img>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title :class="large ? 'text-h5' : null">{{ computedTitle }}</v-list-item-title>

      <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action v-if="icon">
      <v-btn icon>
        <v-icon @click="$emit('icon')" color="text--lighten-2">{{ icon }}</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<style scoped>
.search-tile {
  transition: background-color 0.25s ease-out;
}
.search-tile:hover {
  background-color: rgba(0, 0, 0, 0.07);
}
</style>

<script>
import getAspectRatio from "../../util/getAspectRatio";

export default {
  name: "search-tile",

  props: {
    large: { type: Boolean, default: false },

    icon: { type: String, default: "" },

    isSet: { type: Boolean, default: true },
    title: { type: String, default: "Unavailable" },
    subtitle: { type: String },

    medium: { type: String },
    image: { type: String, default: "https://telemonial.com/unknown.png" },
  },

  computed: {
    aspect() {
      return getAspectRatio(this.medium);
    },

    computedTitle() {
      return this.isSet ? this.title : "No Favorite Set";
    },
  },
};
</script>
